<template>
  <div>
    <yandex-map :coords="[55.4885572071322,28.786285621476857]" @click="onClick" :zoom="14.5" :scroll-zoom="false" >
      <ymap-marker
        marker-id="1" 
        :coords="coords1"
        :balloon-template="balloonTemplate1"
        :icon="markerIcon1">
      </ymap-marker>

     <ymap-marker
        marker-id="2" 
        :coords="coords2"
        :balloon-template="balloonTemplate2"
        :icon="markerIcon2">
      </ymap-marker>
       
       <ymap-marker
        marker-id="3" 
        :coords="coords3"
        :balloon-template="balloonTemplate3"
        :icon="markerIcon3">
      </ymap-marker>

      <ymap-marker
        marker-id="4" 
        :coords="coords4"
        :balloon-template="balloonTemplate4"
        :icon="markerIcon4">
      </ymap-marker>

      <ymap-marker
        marker-id="5" 
        :coords="coords5"
        :balloon-template="balloonTemplate5"
        :icon="markerIcon5">
      </ymap-marker>

      <ymap-marker
        marker-id="6" 
        :coords="coords6"
        :balloon-template="balloonTemplate6"
        :icon="markerIcon6">
      </ymap-marker>
      
    </yandex-map>
  </div>
</template>

<script>
export default {
  data: () => ({
    coords1: [55.52519640174113,28.673674654039058],
    coords2: [55.48705958539872,28.78323520048831],
    coords3: [55.4875572071322,28.786285621476857],
    coords4: [55.4903140251911,28.78012176526849],
    coords5: [55.49011573253378,28.78347923084955],
    coords6: [55.48890506489891,28.776690599028985],
        markerIcon1: {
          layout: 'default#imageWithContent',
          imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2FnumbersForMap%2F1.png?alt=media&token=a4c57655-0b9a-4f90-8fae-7b55c2d776aa',
          imageSize: [43, 43],
          imageOffset: [-10, -20],
          // content: '1',
          // contentOffset: [0, 18],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        },
        markerIcon2: {
          layout: 'default#imageWithContent',
          imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2FnumbersForMap%2F2.png?alt=media&token=ccce0f43-2d34-47a6-b5ad-d160978c559c',
          imageSize: [43, 43],
          imageOffset: [-10, -20],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        },
         markerIcon3: {
          layout: 'default#imageWithContent',
          imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2FnumbersForMap%2F3.png?alt=media&token=04da299d-a064-4f4a-a8cd-e685c2969bdf',
          imageSize: [43, 43],
          imageOffset: [-10, -20],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        },
         markerIcon4: {
          layout: 'default#imageWithContent',
          imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2FnumbersForMap%2F4.png?alt=media&token=3e0ebd1b-07e0-48f1-bf3a-5bb2571831de',
          imageSize: [43, 43],
          imageOffset: [-10, -20],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        },
         markerIcon5: {
          layout: 'default#imageWithContent',
          imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2FnumbersForMap%2F5.png?alt=media&token=10602f5a-fa0e-49b4-a283-45f4226d3cea',
          imageSize: [43, 43],
          imageOffset: [-10, -20],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        },
         markerIcon6: {
          layout: 'default#imageWithContent',
          imageHref: 'https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2FnumbersForMap%2F6.png?alt=media&token=0fe9908c-10ad-4459-b3ed-c24533653edd',
          imageSize: [43, 43],
          imageOffset: [-10, -20],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        }
      
     
    
  }),

  computed: {
    balloonTemplate1() {
      return `
        <h1 class="white">Кафе "СУШИWOK"</h1>
         <p>Координаты GPS: ${this.coords1}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F1%2F1.jpg?alt=media&token=7e05acf9-cbbe-45c5-a63a-1ea4af34e222">
      `
    },
    balloonTemplate2() {
      return `
        <h1 class="white">Зоомагазин "Таити"</h1>
         <p>Координаты GPS: ${this.coords2}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F2%2F2.jpg?alt=media&token=5d7e5e9d-1653-4edf-99fb-f7f2abeda54a">
      `
    },
    balloonTemplate3() {
      return `
        <h1 class="white">Зоомагазин "Мокрый Нос"</h1>
         <p>Координаты GPS: ${this.coords3}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F3%2F3.jpg?alt=media&token=525c5006-cdfe-476e-9b13-2f8199fa8af0">
      `
    },
    balloonTemplate4() {
      return `
        <h1 class="white">Зоомагазин "Таити"</h1>
         <p>Координаты GPS: ${this.coords4}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F4%2F4.jpg?alt=media&token=eef364c7-b61d-49c3-8410-7341a5c2b75d">
      `
    },
    balloonTemplate5() {
      return `
        <h1 class="white">Парикмахерская "Вояж"</h1>
         <p>Координаты GPS: ${this.coords5}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F5%2F5.jpg?alt=media&token=010e3b5c-6dee-4f63-87a5-f872a79a49f5">
      `
    },
    balloonTemplate6() {
      return `
        <h1 class="white">Кафе "БyFet"</h1>
         <p>Координаты GPS: ${this.coords6}</p>
        <img src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F6%2F6.jpg?alt=media&token=af3b4633-4cfb-4f9c-b725-6b4e507ab548">
      `
    }
  },
  methods: {
    onClick(e) {
      this.coords = e.get('coords');
    }
  }  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.ymap-container {
  height: 600px;
}
.green {
  color: green;
}
</style>